import { useMutation } from '@tanstack/react-query';
import api from 'services/api';

const useOrganizationRestore = () => {
  const restoreOrganization = async (orgId,req) => {
    try {
      const response = await api.post(
        `api/v1/organizations/${orgId}/restore`,
        JSON.stringify(req)
      );

      const data = await response.json();

      return data.data;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return useMutation(({ req,orgId }) => restoreOrganization(orgId,req), {});
};

export default useOrganizationRestore;